import { userSlice } from "./reducers";

export const { reset_state, setUser } = userSlice.actions;
export default userSlice.actions;
